import {Switch, Route, Redirect} from "react-router-dom"

import List from "./Components/List";
import Details from "./Components/Details";

import FormAddEvent from "./Components/FormAddEvent";
import FormRegister from "./Components/FormRegister";
import Success from "./Components/Success";
import Error404 from "./Components/404";
import EditEvent from "./Components/EditEvent";

function App() {

  return (
    <div className="App">
      <Switch>
        <Route exact path="/listar-eventos/i0520c8a892bf11eda1eb0242ac120002" component={List} />
        <Route path="/detalle/:codigo"  component={Details} />

        <Route exact path="/crear-evento" component={FormAddEvent} />
        <Route exact path="/editar-evento/:codigo" component={EditEvent} />

        <Route exact path="/registro/:slug" component={FormRegister} />
        {/* 
          <Route exact path="/registro/:slug/resultado" component={Success} />
        */}

        <Route exact path="/evento-no-encontrado" component={Error404} />
        <Route exact path="*" component={Error404} />
        {/*
        <Redirect from="/" to="/listar-eventos/i0520c8a892bf11eda1eb0242ac120002" />
        */}
      </Switch>
    </div>
  );
  
}

export default App;
